"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLICKSTREAM_SCHEMA_DATA = exports.CLICKSTREAM_EVENT_TYPE = void 0;
var CLICKSTREAM_EVENT_TYPE = {
  IMPRESSION: 'impression',
  INTENT_TO_SHOW: 'intent_to_show',
  INTERACTION: 'interaction',
  HOVER: 'hover',
  CLOSE: 'close',
  EXPOSURE: 'exposure'
};
exports.CLICKSTREAM_EVENT_TYPE = CLICKSTREAM_EVENT_TYPE;

var VIEW_TRIGGER_SOURCE_VALUE = function VIEW_TRIGGER_SOURCE_VALUE(value) {
  return "onsite_message_component|" + value;
};

var INTERACT_TRIGGER_SOURCE_VALUE = function INTERACT_TRIGGER_SOURCE_VALUE(value) {
  return "button_to_interact_with_" + value + "_onsite_message";
};

var INTERACT_TRIGGER_SOURCE_VALUE_SECONDARY = function INTERACT_TRIGGER_SOURCE_VALUE_SECONDARY(value) {
  return "button_to_interact_with_" + value + "_secondary_onsite_message";
};

var CLICKSTREAM_SCHEMA_DATA = function CLICKSTREAM_SCHEMA_DATA(triggerLocation, triggerObject, triggerSource, isSecondary) {
  var _ref;

  return _ref = {}, _ref[CLICKSTREAM_EVENT_TYPE.IMPRESSION] = {
    envelopeBlock: {
      event_template_id: '1',
      event_template_version_id: '1',
      event_type_id: '33',
      event_type_version_id: '2'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'impression',
      trigger_object_nm: triggerObject !== null && triggerObject !== void 0 ? triggerObject : 'no_trigger_object',
      trigger_source_nm: VIEW_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'omp_placement_view',
      topic_tag_txt: ['omp']
    }
  }, _ref[CLICKSTREAM_EVENT_TYPE.INTERACTION] = {
    envelopeBlock: {
      event_template_id: '1',
      event_template_version_id: '1',
      event_type_id: '34',
      event_type_version_id: '3'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: isSecondary ? INTERACT_TRIGGER_SOURCE_VALUE_SECONDARY(triggerSource) : INTERACT_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'omp_placement_interaction',
      topic_tag_txt: ['omp']
    }
  }, _ref[CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW] = {
    envelopeBlock: {
      event_template_id: '1',
      event_template_version_id: '1',
      event_type_id: '2034',
      event_type_version_id: '2'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'impression',
      trigger_object_nm: triggerObject !== null && triggerObject !== void 0 ? triggerObject : 'no_trigger_object',
      trigger_source_nm: VIEW_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'omp_placement_intent_to_show',
      topic_tag_txt: ['omp']
    }
  }, _ref[CLICKSTREAM_EVENT_TYPE.HOVER] = {
    envelopeBlock: {
      event_template_id: '1',
      event_template_version_id: '1',
      event_type_id: '2044',
      event_type_version_id: '3'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: isSecondary ? INTERACT_TRIGGER_SOURCE_VALUE_SECONDARY(triggerSource) : INTERACT_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'omp_placement_hover_cta',
      topic_tag_txt: ['omp']
    }
  }, _ref[CLICKSTREAM_EVENT_TYPE.CLOSE] = {
    envelopeBlock: {
      event_template_id: '1',
      event_template_version_id: '1',
      event_type_id: '2045',
      event_type_version_id: '2'
    },
    triggerBlock: {
      trigger_location_nm: triggerLocation,
      trigger_type_nm: 'interaction',
      trigger_object_nm: triggerObject,
      trigger_source_nm: INTERACT_TRIGGER_SOURCE_VALUE(triggerSource)
    },
    semanticBlock: {
      semantic_event_nm: 'omp_placement_close_cta',
      topic_tag_txt: ['omp']
    }
  }, _ref[CLICKSTREAM_EVENT_TYPE.EXPOSURE] = {
    envelopeBlock: {
      event_template_id: '138',
      event_template_version_id: '1',
      event_type_id: '1950',
      event_type_version_id: '1'
    },
    semanticBlock: {
      semantic_event_nm: 'exposure',
      topic_tag_txt: ['exposure', 'adtech-product']
    }
  }, _ref;
};

exports.CLICKSTREAM_SCHEMA_DATA = CLICKSTREAM_SCHEMA_DATA;